import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { MailToLinkPipe, PhonePipe } from '../../../../../@core/pipes';
import { Contact } from '../../../../../generated/generated-types';

@Component({
  selector: 'app-contact-card-widget',
  templateUrl: './contact-card-widget.component.html',
  styleUrls: ['./contact-card-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardModule,
    CommonModule,
    TranslatePipe,
    TooltipModule,
    PhonePipe,
    MailToLinkPipe
  ]
})
/**
 * @deprecated use contact-header-card-widget instead
 */
export class ContactCardWidgetComponent {

  cdRef = inject(ChangeDetectorRef);

  @Input({ required: true })
  contact: Contact;

  update() {
    this.cdRef.detectChanges();
  }

}
